export default "/images/vendor/flag-icons/flags/1x1/sg.svg?ea78850709c27e574141917620d099ee";